<template>
<div v-if="formVisible">
    <!--蒙层-->
    <div class="dt-mask-box"></div>
    <div class="dt-update-box">
        <div class="dt-update-header-right click-element">
            <i class="dt-update-close-icon" v-on:click="closeModal"></i>
        </div>
        <div class="dt-update-content">
            <p class="dt-update-title">{{pageTitle}}管理平台升级成功啦！</p>
            <p class="dt-update-info">全面升级，全新体验!</p>
        </div>
        <div class="dt-update-btn click-element" @click="closeModal">
            立即体验
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'version-update',
    props: ['formVisible'],
    data() {
        return {
            pageTitle: process.env.VUE_APP_PAGE_TITLE
        };
    },
    methods: {
        /**
         * 关闭弹框
         */
        closeModal() {
            this.$emit("close-update-box");
        }
    }
};
</script>

<style lang="scss" scoped>
.dt-mask-box {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #000;
    height: 100%;
    z-index: 1000;
    opacity: 0.6;
}

.dt-update-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    height: 408px;
    margin: 0 auto;
    z-index: 1001;
    background-image: url("../assets/icon_update_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    line-height: 1.125;

    .dt-update-header-right {
        position: absolute;
        top: 32px;
        right: 18px;

        .dt-update-close-icon {
            width: 20px;
            height: 20px;
            background: url("../assets/icon_web_close.png") no-repeat;
            display: block;
        }
    }

    .dt-update-content {
        padding-top: 197px;
        text-align: center;
    }

    .dt-update-title {
        font-size: 20px;
        color: #333;
    }

    .dt-update-info {
        margin-top: 20px;
        font-size: 18px;
        color: #666;
    }

    .dt-update-btn {
        width: 160px;
        height: 48px;
        line-height: 48px;
        background: linear-gradient(180deg, rgba(12, 201, 255, 1) 0%, rgba(19, 141, 255, 1) 100%);
        border-radius: 24px;
        text-align: center;
        color: #fff;
        font-size: 20px;
        margin: 0 auto;
        margin-top: 30px;
    }

}
</style>
